// import Chart from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
import { upgradeModule } from '@uirouter/angular-hybrid';
agGrid.initialiseAgGridWithAngular1(angular);
import { AppAngularComponentsModule } from "src/app/app-angular-components.module";
import { TokenLoginPageModule } from "./partials/tokenLogin/token-login-page.module";
import { CandidateConferencePageModule } from "./partials/candidateConference/candidate-conference-page.module";
import { ExitMeetingPageModule } from "./partials/exitMeeting/exit-meeting-page.module";
import { FiltersModule } from "./filters/filters.module";
import { ConstantsModule } from "./constants.module";
import { SharedModule } from "./shared/shared.module";
import { MissionControlModule } from "./partials/missioncontrol/mission-control.module";
import { AppAjsComponent } from "../../app.component.ajs";
import { LoginPageAjsModule } from 'src/app/pages/login-page/login-page-ajs.module';
import { ResetPasswordPageAjsModule } from 'src/app/pages/reset-password-page/reset-password-page-ajs.module';
import { ForgotPasswordPageAjsModule } from "../../pages/forgot-password-page/forgot-password-page-ajs.module";
import { ValidateOtpPageAjsModule } from 'src/app/pages/validate-otp-page/validate-otp-page-ajs.module';
export const appAjsModule = angular
    .module('4dot5', [upgradeModule.name, 'ngAnimate', 'ngSanitize', 'ui.bootstrap', 'angularMoment', 'agGrid', 'chart.js',
    'ngCookies', 'ngPrint', 'ngNotify', 'ngToast', 'ngIntlTelInput',
    'datatables', 'datatables.bootstrap', 'datatables.buttons',
    'dndLists', 'isteven-multi-select', 'infinite-scroll', 'easypiechart',
    'angular-loading-bar', 'angularSpinner', 'imageupload', 'angular.vertilize', 'ngTagsInput',
    'angular-timezone-selector', 'ui.tree', 'textAngular',
    '4dot5.directivesModule',
    AppAngularComponentsModule,
    FiltersModule,
    ConstantsModule,
    TokenLoginPageModule,
    CandidateConferencePageModule,
    ExitMeetingPageModule,
    SharedModule,
    MissionControlModule,
    //Migrated
    LoginPageAjsModule,
    ResetPasswordPageAjsModule,
    ForgotPasswordPageAjsModule,
    ValidateOtpPageAjsModule
])
    .run([
    '$rootScope',
    '$state',
    '$location',
    'ngNotify',
    'StorageService',
    'appVersionService',
    'userService',
    'planService',
    'webSocketsService',
    'modalService',
    'stateLocationService',
    '$exceptionHandler',
    'MESSAGECONSTANTS',
    '$templateCache',
    '$trace',
    '$transitions',
    'sharedAjsService',
    ($rootScope, $state, $location, ngNotify, StorageService, appVersionService, userService, planService, webSocketsService, modalService, stateLocationService, $exceptionHandler, MESSAGECONSTANTS, $templateCache, $trace, $transitions, sharedAjsService) => {
        $rootScope.appLoaded = true;
        $rootScope.showHeaderNav = true;
        $rootScope.angular = angular;
        $rootScope.MESSAGECONSTANTS = MESSAGECONSTANTS;
        $rootScope.tokenvalidity = 24 * 60 * 60 * 1000; //One day validity;
        $rootScope.refreshtokenvalidity = 21 * 24 * 60 * 60 * 1000; // Twenty One days Validity;
        $rootScope.isOffline = false;
        $rootScope.showBrowserRefreshMessage = false;
        appVersionService.initVersionCheck();
        // $rootScope.tokenvalidity =  2 * 60 * 1000; //five minute validity;
        // $rootScope.refreshtokenvalidity = 60 * 60 * 1000; // sixty minute Validity;
        $rootScope.systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        $rootScope.defaultCountryCode = 'US';
        $rootScope.disableScreen = false;
        /**
         * This is absolute path for image folder from where required images are loaded
         */
        $rootScope.imageUrl = 'assets/app-content/img/';
        /**
         * Base url for API call should be configured here.
         */
        StorageService.set('baseurl', '');
        /*
            ng notify default configuration
         */
        ngNotify.config({
            position: 'top'
        });
        $trace.enable('TRANSITION');
        let _currentScreenDoesNotRequireLogin = (trans) => {
            return trans.to().name == 'login'
                || trans.to().name == 'setpassword'
                || trans.to().name == 'resetPassword'
                || trans.to().name == 'validateOtp'
                || trans.to().name == 'authenticateToken'
                || trans.to().name == 'forgotPassword'
                // || trans.to().name == 'conference' 
                || trans.to().name == 'candidateConference'
                || trans.to().name == 'tokenLogin';
        };
        $transitions.onStart({}, function (trans) {
            $rootScope.showHeaderNav = true;
            // Aborting Transition
            if (trans.to().name === 'unreachable') {
                return false;
            }
            if (!_currentScreenDoesNotRequireLogin(trans)) {
                StorageService.remove('wizardoperations');
                //console.log('userDetails  c : ' + angular.toJson(StorageService.get('userDetails')));
                var userDetails = StorageService.get('userDetails');
                //console.log('User details: '+angular.toJson(userDetails));
                // && angular.isDefined(userDetails.accesstoken)
                if (!_.isNull(userDetails) && !_.isUndefined(userDetails) && !_.isUndefined(userDetails.accountState)) {
                    if (userDetails.accountState === $rootScope.MESSAGECONSTANTS.USER_STATES.ACTIVE) {
                        $rootScope.userDetails = userDetails;
                        $rootScope.userActive = true;
                        if (!_.isNull(userDetails.plan.message) && userDetails.plan.message.length > 0) {
                            $rootScope.userDetails.plan.message = planService.getPlanExpiryMessage(userDetails.plan.planType, moment(userDetails.plan.endDate), false);
                        }
                        //console.log('Setting user active true : ' + angular.toJson($rootScope.userDetails));
                    }
                }
                else {
                    //console.log('going to login page');
                    // event.preventDefault();
                    console.log(StorageService.get('baseurl'));
                    console.log('redirecting to login');
                    StorageService.set('baseurl', '');
                    // trans.router.stateService.target('login');
                    $state.go('login', null, { reload: true });
                }
            }
            /**
           * This condition checks
           * 1. After login clicks on backbutton should not come to  login
           */
            if (trans.to().name === 'login') {
                /**
                 * Checking Remember Me because
                 * when login irrespective of what ever check is made rememberme will be stored
                 */
                var rememberme = StorageService.getCookie('rememberme');
                var userDetails = StorageService.get('userDetails');
                //console.log('rememberme : ' + angular.toJson(rememberme));
                //console.log('userDetails : ' + angular.toJson(userDetails));
                //console.log('fromState : ' + angular.toJson(fromState));
                if (!_.isUndefined(rememberme) && !_.isNull(rememberme) && !_.isUndefined(userDetails) && !_.isNull(userDetails)) {
                    // event.preventDefault();
                    $rootScope.userActive = true;
                    $rootScope.userDetails = StorageService.get('userDetails');
                    webSocketsService.connect();
                    if (trans.from().name === '') {
                        // get login params to redirect user after login to screen/modal
                        let loginParamsObject = sharedAjsService._setLoginParameters($location.search());
                        // userService.navigateToHomeScreen();
                        sharedAjsService.navigateToHomeScreen(loginParamsObject);
                    }
                    else {
                        trans.router.stateService.target(trans.from().name, trans.params());
                        // $state.go(transition.from().name, transition.params(), { reload: false });
                    }
                }
            }
        });
        /*  $rootScope.$on('$routeChangeStart', function(event, next, current) {
              if (typeof(current) !== 'undefined'){
                  $templateCache.remove(current.templateUrl);
              }
          });*/
        /**
         * @link https://github.com/angular-ui/ui-router/wiki#state-change-events
         */
        /**
         * When page is reloded or state is changed, view will be scrolled to top.
         * @link https://github.com/angular-ui/ui-router/wiki#state-change-events
         */
        $transitions.onSuccess({}, function (transition) {
            $("html, body").animate({ scrollTop: 0 }, 'slow');
            stateLocationService.stateChange();
            return false;
        });
        // $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
        //     $("html, body").animate({ scrollTop: 0 }, 'slow');
        //     stateLocationService.stateChange();
        //     return false;
        // });
        $transitions.onError({}, function (transition) {
            console.log("state change error - " + transition.error());
        });
        window.myAppErrorLog = [];
        $state.defaultErrorHandler((error) => {
            // This is a naive example of how to silence the default error handler.
            window.myAppErrorLog.push(error);
            console.log("state change error - ", error);
        });
        // $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
        //     console.log("state change error - ", error);
        // });
        $rootScope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl, newState, oldState) {
            // re establish web socket connection, if it is a page refresh
            // if newUrl equals OldUrl, it is a refresh
            if (angular.equals(newUrl, oldUrl)) {
                var isUserLoginRequiredScreen = !userService.isScreenWithLoginNotRequired(newUrl);
                // make sure it is not a login not required page refresh
                if ($location.url() !== "" && $location.url() !== "/" && isUserLoginRequiredScreen) {
                    // open the web socket connection
                    webSocketsService.connect();
                }
            }
            stateLocationService.locationChange();
            // close any open modals
            modalService.closeAllOpenModals();
        });
        $rootScope.$on('sessionInvalidated', function (event, toState, toParams, fromState) {
            $rootScope.$emit("CallLogoutMethod", { logoutnow: true });
        });
        $rootScope.throwError = function (error) {
            if (angular.isDefined(error.developerMsg) && (error.developerMsg !== null)) {
                try {
                    throw new Error(error.message);
                }
                catch (except) {
                    $exceptionHandler(except, error.developerMsg);
                }
            }
        };
    }
])
    .config(['$provide', '$httpProvider', 'cfpLoadingBarProvider', 'ngToastProvider', 'ngIntlTelInputProvider', '$stateProvider', '$urlRouterProvider', ($provide, $httpProvider, cfpLoadingBarProvider, ngToast, ngIntlTelInputProvider, $stateProvider, $urlRouterProvider) => {
        cfpLoadingBarProvider.includeBar = true;
        cfpLoadingBarProvider.includeSpinner = true;
        cfpLoadingBarProvider.latencyThreshold = 100;
        // $stateProvider.state('appRoot', {
        //     url: '/',
        //     component: AppComponent.selector
        // });
        // $urlRouterProvider.otherwise("/login");
        ngToast.configure({
            // verticalPosition: 'center',
            // horizontalPosition: 'top',
            maxNumber: 1,
            animation: 'slide',
            dismissButton: true,
            duration: 4000
        });
        ngIntlTelInputProvider.set({
            initialCountry: 'us',
            utilsScript: 'assets/app-content/js/utils.js',
            autoPlaceholder: 'aggressive',
            formatOnDisplay: true,
            nationalMode: false
        });
        $provide.decorator("$exceptionHandler", ['$log', '$delegate', '$injector', function ($log, $delegate, $injector) {
                return function (exception, cause) {
                    console.info('CONFIG CATCH');
                    let alertsAndNotificationsService = $injector.get('alertsAndNotificationsService');
                    let genericService = $injector.get('genericService');
                    let StorageService = $injector.get('StorageService');
                    let previousException = window.localStorage.getItem("exception");
                    if (previousException == exception) {
                        console.log("Not raising ticket as the previous exception was same");
                    }
                    else {
                        let exceptionsString = window.localStorage.getItem("exceptions");
                        let previousExceptions = exceptionsString ? JSON.parse(exceptionsString) : [];
                        if (previousExceptions.length < 5) {
                            console.log("Raising error ticket");
                            let requestBody = {
                                error: exception.message,
                                stack: exception.stack
                            };
                            // api call to create support ticket
                            genericService.addObject(StorageService.get('baseurl') + 'api/uierrorsupport/createUISupportTicket', requestBody).subscribe((data) => {
                                console.log('support ticket request sent');
                            }, (error) => {
                                console.log('support ticket request fail');
                            });
                            window.localStorage.setItem("exception", exception);
                            previousExceptions.push(exception.error);
                            window.localStorage.setItem("exceptions", JSON.stringify(previousExceptions));
                        }
                        else {
                            console.log("Not raising ticket as calls have exceeded the limit of 5");
                        }
                    }
                    //Log error in console
                    $delegate(exception, cause);
                    if (angular.isDefined(cause)) {
                        var rootScopeVariable = $injector.get('$rootScope');
                        alertsAndNotificationsService.showBannerMessage(exception, 'danger');
                    }
                };
            }]);
        $httpProvider.defaults.timeout = 5000;
        $httpProvider.interceptors.push('interceptorService');
    }])
    .component(AppAjsComponent.selector, AppAjsComponent.component)
    .name;
//# sourceMappingURL=app.module.ajs.js.map